<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="col-md-12">
          <ol class="breadcrumb breadcrumb-card-header pull-left">
            <li class="breadcrumb-item">
              <a href="javascript:void(0);" @click="backParent"> Delivery</a>
            </li>
            <li class="breadcrumb-item active">
              <span v-if="delivery.id === null">New</span>
              <span v-else>
                {{ delivery.deliver_no }}
              </span>
            </li>
          </ol>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group row">
              <label for="delivery_no" class="col-sm-3 col-form-label text-left">Delivery Number</label>
              <div class="col-sm-9">
                <input type="text" v-model="delivery.deliver_no" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
              <div class="col-sm-9">
                <input type="text" v-model="delivery.name" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
              <div class="col-sm-9">
                <textarea rows="5" v-model="delivery.address" class="form-control"></textarea>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group row">
              <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
              <div class="col-sm-9">
                <input type="text" v-model="delivery.phone" class="form-control"/>
              </div>
            </div>
            <div class="form-group row">
              <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
              <div class="col-sm-9">
                <input type="text" class="form-control" v-model="delivery.email"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button type="button" @click="backParent" class="btn btn-sm btn-danger pull-left"><i class="fa fa-reply" aria-hidden="true"></i> Back</button>
        <button type="button" @click="updateDelivery" class="btn btn-sm btn-primary pull-right" v-show="delivery.id !== null"><i class="fa fa-save" aria-hidden="true"></i> Update</button>
        <button type="button" @click="createDelivery" class="btn btn-sm btn-primary pull-right" v-show="delivery.id == null"><i class="fa fa-check" aria-hidden="true"></i> Save</button>
      </div>
    </div>
    <pre>
      <!-- {{ delivery }} -->
    </pre>
  </div>
</template>

<script>
import axios from 'axios'
import { deliveryUrl, getHeader } from '../../config'

export default {
  name: 'DeliveryForm',
  props: ['delivery'],
  methods: {
    backParent: function () {
      this.$emit('backClicked')
    },
    updateDelivery () {
      axios.put(deliveryUrl + '/' + this.delivery.id, this.delivery, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$swal('Delivery', response.data.message, 'success')
          this.$emit('backClicked')
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error!!', '', 'error')
        })
    },
    createDelivery () {
      axios.post(deliveryUrl, this.delivery, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('backClicked')
        })
        .catch(response => {
          console.log(response)
          this.$swal('Error!!', response.data, 'error')
        })
    }
  }
}
</script>
